module.exports = __webpack_public_path__ + "img/close_ico_5_5.15e2d08b.svg";